import React, { ReactNode } from 'react';
import { useCharity } from '../../hooks/useCharity';
import Loading from '@justgiving/loading';
import config from '../../config';
import { PageType } from '../../../types/graphql';
import { usePathInfo } from '../../hooks';
import { CustomError } from '../ErrorBoundary/errors';

interface AuthoriserProps {
  children?: ReactNode;
}

const CharityAuthoriser = ({ children }: AuthoriserProps) => {
  const { data: charity, loading } = useCharity();
  const { pageType, pageSlug } = usePathInfo();

  if (loading) {
    return <Loading />;
  }

  if (!charity?.isApproved) {
    window.location.assign(config.charityHomeUrl);
  }

  const slug = pageSlug.slice(pageSlug.lastIndexOf('/') + 1);
  const charitySlug =
    charity?.slug?.indexOf('/') !== -1
      ? charity?.slug?.slice(charity?.slug?.lastIndexOf('/') + 1)
      : charity?.slug;

  if (
    pageType === PageType.Charity &&
    slug?.toLowerCase() !== charitySlug?.toLowerCase()
  ) {
    throw new CustomError({
      message: 'User does not have the correct permissions',
      code: 500,
    });
  }

  return <>{children}</>;
};

export { CharityAuthoriser };
